import { render } from "./Maintwo.vue?vue&type=template&id=a53156a4&scoped=true"
import script from "./Maintwo.vue?vue&type=script&lang=js"
export * from "./Maintwo.vue?vue&type=script&lang=js"

import "./Maintwo.vue?vue&type=style&index=0&id=a53156a4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a53156a4"]])

export default __exports__